import { AxiosResponse } from 'axios';
import api from './api';
import { PaginationResponse, PaginationParams } from '@/types';

/**
 * Função genérica para buscar todos os itens com paginação
 */
export async function fetchAll<T>(
  endpoint: string,
  filters?: PaginationParams
): Promise<PaginationResponse<T>> {
  const response: AxiosResponse<PaginationResponse<T>> = await api.get(endpoint, {
    params: filters,
  });
  return response.data;
}

/**
 * Função genérica para buscar item por ID
 */
export async function fetchById<T>(
  endpoint: string,
  id: number
): Promise<T> {
  const response: AxiosResponse<T> = await api.get(`${endpoint}/${id}`);
  return response.data;
}

/**
 * Função genérica para criar item
 */
export async function create<T, D = Partial<T>>(
  endpoint: string,
  data: D
): Promise<T> {
  const response: AxiosResponse<T> = await api.post(endpoint, data);
  return response.data;
}

/**
 * Função genérica para atualizar item
 */
export async function update<T, D = Partial<T>>(
  endpoint: string,
  id: number,
  data: D
): Promise<T> {
  const response: AxiosResponse<T> = await api.put(`${endpoint}/${id}`, data);
  return response.data;
}

/**
 * Função genérica para deletar item
 */
export async function deleteById(
  endpoint: string,
  id: number
): Promise<void> {
  await api.delete(`${endpoint}/${id}`);
}

/**
 * Função genérica para buscar por campo customizado
 */
export async function fetchBy<T>(
  endpoint: string,
  field: string,
  value: string | number
): Promise<T[]> {
  const response: AxiosResponse<T[]> = await api.get(`${endpoint}/${field}/${value}`);
  return response.data;
}
